import React, {Dispatch, SetStateAction} from 'react';

import LoginHeader from '@/containers/LoginPageV2/components/LoginHeader';
import type {LoginErrorDetails} from '@/containers/LoginPageV2/LoginPageV2.types';
import {getLoginContent} from '@/services/content/appContent.typed';

import usePasswordLoginHandler from '../../hooks/usePasswordLoginHandler';
import LoginForm from './LoginForm';

interface PasswordLoginFormProps {
    isLoginLanguageSelectEnabled?: boolean;
    loginError: LoginErrorDetails;
    setLoginError: Dispatch<SetStateAction<LoginErrorDetails>>;
}

const PasswordLoginForm = ({isLoginLanguageSelectEnabled, setLoginError, ...rest}: PasswordLoginFormProps) => {
    const {title} = getLoginContent();
    const handlePasswordLogin = usePasswordLoginHandler(setLoginError);

    return (
        <>
            <LoginHeader title={title} isLanguageSelectEnabled={isLoginLanguageSelectEnabled} />
            <LoginForm setLoginError={setLoginError} onLogin={handlePasswordLogin} {...rest} />
        </>
    );
};

export default PasswordLoginForm;
